<template>
  <!-- 精准教学 -->
  <div class="jingzhunjiaoxue">
    <PublicScore :logo="Logo4" :type="'jzjx'" :color="'#159b7b'" />
  </div>
</template>

<script>
import PublicScore from '../component/scoreQuery.vue'
import Logo4 from '@/assets/images/logo4.png'

export default {
  name: 'JingZhunJiaoXue',
  components: {
    PublicScore
  },
  data() {
    return {
      Logo4
    }
  }
}
</script>
